import HikiukeCompanyResultSection from './HikiukeCompanyResultSection.js';

const HikiukeSearchResults = ({ searchResults, selectedResults, setSelectedResults, isMobile }) => {
  return (
    <div className="hikiuke-search-results-container">
      {searchResults.map((company, index) => (
        <HikiukeCompanyResultSection
          key={company.company}
          company={company}
          selectedResults={selectedResults}
          setSelectedResults={setSelectedResults}
          isMobile={isMobile}
        />
      ))}
    </div>
  );
};

export default HikiukeSearchResults;